var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float_btn"},[_c('a',{attrs:{"target":"_blank"},on:{"click":_vm.fbShare}},[_c('img',{attrs:{"src":require("@/assets/images/icon/fb-icon.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }